enum OutlineShadesEnum {
  OUTLINE_LIGHT = "outline-light",
  OUTLINE_DARK = "outline-dark"
}
export default OutlineShadesEnum;
